import {pageInfo, expressDispatchPreCheck, expressDispatchSubmit} from './../api';
const transportExpress = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    rePushObj: null,
    expressDispatchPreCheckResp: null,
    expressDispatchSubmitObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, item.dealStatus == '处理失败'] }));
    },
    EXPRESS_DISPATCH_PRE_CHECK(state, data) {
      state.expressDispatchPreCheckResp = data;
    },
    EXPRESS_DISPATCH_SUBMIT(state, data) {
      state.expressDispatchSubmitObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async expressDispatchPreCheck({commit}, obj) {
      let resp = await expressDispatchPreCheck(obj);
      commit('EXPRESS_DISPATCH_PRE_CHECK', resp);
    },

    async expressDispatchSubmit({commit}, obj) {
      let resp = await expressDispatchSubmit(obj);
      commit('EXPRESS_DISPATCH_SUBMIT', resp);
    },
  }
}
export default transportExpress



// WEBPACK FOOTER //
// ./src/page/transport/transportExpress/store/transportExpress.store.js